import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './global.css'
import { branding } from '@/config/branding'

// Set document title based on branding
document.title = branding.appName

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('Failed to find the root element')
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
